import { Api } from './Api'

class OrganizationSetting {
  getPromise (customerId) {
    return fetch(`${Api.getBaseUrl()}organizationsetting/${customerId}`, Api.getOptions())
  }
}

export default OrganizationSetting
